let sp = new URLSearchParams(location.search);
let log = sp.get('log');
window.log = (...params) => {
  if (log == 1) {
    console.info(...params);
  }
};
